import { Controller } from "@hotwired/stimulus"

// Locks the platform-synced fields of a destination once the remote resource exists (an Amazon DSP
// conversion definition, a LinkedIn conversion rule), and unlocks them in place on demand.
//
// The locked field group renders with the `inert` attribute: it's visible and still submits its
// current values, but can't be focused or edited — so there are no disabled inputs and no hidden
// fallbacks to reconcile (an enabled input inside an `inert` ancestor is still a successful form
// control). Clicking the Edit button removes `inert`, drops the dim, hides the button, and reveals
// a short notice that the change will sync to the platform on save.
export default class extends Controller {
  static targets = ["fields", "editButton", "notice"]

  unlock() {
    this.fieldsTarget.removeAttribute("inert")
    this.fieldsTarget.classList.remove("opacity-60")

    if (this.hasEditButtonTarget) this.editButtonTarget.classList.add("hidden")
    if (this.hasNoticeTarget) this.noticeTarget.classList.remove("hidden")
  }
}
